import {
  OcrBuilder,
  CreateOcrBuilder,
  UpdateOcrBuilder,
  OcrTest,
  TestResult,
  OcrInput,
} from 'types'

import adminFetch from './adminFetch'
import { OCRBUILDERS_CACHE_ID } from './ocrBuilders'

const END_POINT_CONFIG = 'ocrbuilders'

export async function getOcrBuildersConfigs() {
  const { results } = await (adminFetch.get(END_POINT_CONFIG) as Promise<{
    results: OcrBuilder[]
  }>)
  return results
}

export async function testConnection(payload: OcrTest): Promise<TestResult> {
  const formData = new FormData()
  Object.entries(payload).forEach(([key, val]) => {
    formData.append(key, val)
  })

  const res = await adminFetch.postMultipart(END_POINT_CONFIG, formData)
  return res.data
}

export function createOcrBuilderConfig(payload: CreateOcrBuilder) {
  return adminFetch.postInvalidate(
    `${END_POINT_CONFIG}/settings`,
    OCRBUILDERS_CACHE_ID,
    payload,
  )
}

export function updateOcrBuilderConfig(
  ocrBuilderConfigID: number,
  payload: UpdateOcrBuilder | OcrInput,
) {
  return adminFetch.put(
    `${END_POINT_CONFIG}/${ocrBuilderConfigID}`,
    payload,
    OCRBUILDERS_CACHE_ID,
  )
}

interface DelResponse {
  status: 'OK' | 'NG'
  message: string
}

export async function delOcrBuilder(
  id: OcrBuilder['ocrBuilderConfigID'],
): Promise<DelResponse> {
  const { data } = await adminFetch.sendDelete(
    `${END_POINT_CONFIG}/${id}`,
    undefined,
    OCRBUILDERS_CACHE_ID,
  )
  return data
}
